import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import Usps from "./components/usps"
import store from "@/store/"

Vue.use(VueI18n)

const mount = (el) => {
  const { noHeadline, headline, usps } = (el.dataset.config && JSON.parse(el.dataset.config)) || {}

  new Vue({
    name: "UspsMount",
    el,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render(createElement) {
      return createElement(Usps, {
        props: {
          noHeadline,
          headline,
          usps
        }
      })
    }
  })
}

const init = () => {
  const el = document.querySelector(".vue-usps")

  if (el) {
    mount(el)
  }
}

init()
